// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>22</span>&nbsp;&nbsp;My mouth shall speak the praise of the Lord,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and let all flesh bless his holy name for ever and ever.<br> </p> </div></div>";
// Exports
module.exports = code;